import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Loader2, Send } from "lucide-react";
import { API } from "../../lib/scroll";
import { Field } from "./Field";
import { useLang } from "../../lib/i18n";

const EMPTY = { name: "", email: "", subject: "", message: "" };


export const Contact = () => {
  const { t } = useLang();
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    if (!API) return toast.error(t.unavailable);
    setBusy(true);
    try {
      await axios.post(`${API}/contact`, { ...form, subject: form.subject || null });
      toast.success(t.sent);
      setForm(EMPTY);
    } catch (err) {
      toast.error(err?.response?.status === 429 ? t.tooMany : t.failed);
    } finally {
      setBusy(false);
    }
  };
  return (
    <section id="contact-us" data-testid="contact-section" className="border-t border-[#E6D9BC]/10 bg-[#25343E]/40">
      <div className="mx-auto grid max-w-[1440px] gap-16 px-5 py-24 md:px-10 md:py-32 lg:grid-cols-12">
        <motion.div className="lg:col-span-5" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9 }}>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#E6D9BC]">{t.contactEyebrow}</p>
          <h2 className="mt-6 font-display text-5xl leading-[1] text-[#F4EFE6] md:text-6xl">
            {t.contactTitle[0]}<em className="text-[#E6D9BC]">{t.contactTitle[1]}</em>{t.contactTitle[2]}
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-[#BAC6CE]">
            {t.contactBody}
          </p>
        </motion.div>
        <motion.form onSubmit={submit} data-testid="contact-form" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, delay: 0.15 }}
          className="rounded-[32px] border border-[#E6D9BC]/15 bg-[#1E2A32] p-6 sm:p-10 lg:col-span-7">
          <div className="grid gap-6 sm:grid-cols-2">
            <Field label={t.fields[0]} testId="contact-form-name-input" required value={form.name} onChange={set("name")} />
            <Field label={t.fields[1]} type="email" testId="contact-form-email-input" required value={form.email} onChange={set("email")} />
            <Field label={t.fields[2]} testId="contact-form-subject-input" className="sm:col-span-2" value={form.subject} onChange={set("subject")} />
            <Field label={t.fields[3]} as="textarea" rows={5} testId="contact-form-message-input" required minLength={5} className="sm:col-span-2" value={form.message} onChange={set("message")} />
          </div>
          <button type="submit" disabled={busy} data-testid="contact-form-submit-button" className="sw-btn mt-10 w-full justify-center sm:w-auto">
            {busy ? <Loader2 size={18} className="animate-spin" /> : <><Send size={18} /> {t.send}</>}
          </button>
        </motion.form>
      </div>
    </section>
  );
};
